import { render, staticRenderFns } from "./DryCowStrategy.vue?vue&type=template&id=712558c1&"
import script from "./DryCowStrategy.vue?vue&type=script&lang=js&"
export * from "./DryCowStrategy.vue?vue&type=script&lang=js&"
import style0 from "./DryCowStrategy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports